import { IEnvConfig } from "../types";

const config: IEnvConfig = {
    api: {
        default: {
            url: "Test",
            rootPath: ""
        }
    }
};

export default config;
